'use client';

import { useEffect } from 'react';

interface CodeInjectorProps {
  css?: string;
  javascript?: string;
}

const CodeInjector: React.FC<CodeInjectorProps> = ({ css, javascript }) => {
  useEffect(() => {
    let script: HTMLScriptElement | null = null;

    setTimeout(() => {
      if (javascript) {
        script = document?.createElement('script');
        if (script) {
          script.type = 'text/javascript';
          script.text = javascript;
          document?.body?.appendChild(script);
        }
      }
    }, 1000);

    return () => {
      if (script && document?.body) {
        document.body.removeChild(script);
      }
    };
  }, [javascript]);

  // Inject CSS
  if (css) {
    return <style dangerouslySetInnerHTML={{ __html: css }} />;
  }

  return null;
};

export default CodeInjector;
